module.exports = __webpack_public_path__ + "img/budpostach.43a8a126.webp";